<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Campañas</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <router-link
            v-if="$can('store', 'campaigns')"
            :to="{ name: 'CampaignCreate' }"
            class="btn base-button btn-neutral btn-sm"
            >Nuevo</router-link
          >
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <campaigns-table />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import CampaignsTable from './List/CampaignsTable';

export default {
  name: 'CampaignsList',
  components: {
    CampaignsTable,
    RouteBreadCrumb,
  },
};
</script>
